<p-drawer
  [(visible)]="visible"
  (onHide)="close()"
  position="right"
  [modal]="true"
  styleClass="log-drawer"
  [style]="{ width: '480px' }"
  [closable]="true"
>
  <ng-template pTemplate="header">
    <div class="dlg-header" *ngIf="log">
      <div class="dlg-header-text">
        <div class="dlg-header-title">Detalhe do Registo #{{ log.id }}</div>
        <div class="dlg-header-sub">Auditoria de ação efetuada no sistema</div>
      </div>
    </div>
  </ng-template>

  <div class="drawer-body" *ngIf="log">
    <!-- Status & Overview Card -->
    <div class="info-card">
      <div class="info-row">
        <span class="info-label">Ação Executada</span>
        <span
          class="badge"
          [ngClass]="getAcaoClass(log.acaoLogsEnum, log.acaoLogs)"
        >
          <i [class]="getAcaoIcon(log.acaoLogsEnum, log.acaoLogs)"></i>
          {{ log.acaoLogs || 'Desconhecido' }}
        </span>
      </div>

      <div class="info-row">
        <span class="info-label">Entidade Afetada</span>
        <span class="entity-chip">
          <i class="ri-database-2-line"></i> {{ log.entidade || 'N/A' }}
        </span>
      </div>

      <div class="info-row">
        <span class="info-label">Resultado</span>
        <span class="badge" [ngClass]="log.sucesso ? 'badge-success' : 'badge-danger'">
          <i [class]="log.sucesso ? 'ri-checkbox-circle-line' : 'ri-close-circle-line'"></i>
          {{ log.sucesso ? 'Sucesso' : 'Falha' }}
        </span>
      </div>

      <div class="info-row">
        <span class="info-label">Data e Hora</span>
        <span class="info-value">
          <i class="ri-calendar-event-line"></i>
          {{ log.dataCriacaoFormatada || (log.dataCriacao | date:'dd/MM/yyyy HH:mm:ss') }}
        </span>
      </div>
    </div>

    <!-- Section: Utilizador -->
    <div class="details-card">
      <div class="section-title">
        <i class="ri-user-3-line"></i> Informações do Utilizador
      </div>
      <div class="details-grid">
        <div class="detail-item">
          <label>Nome</label>
          <div>{{ log.nome || 'Desconhecido' }}</div>
        </div>
        <div class="detail-item">
          <label>E-mail / Username</label>
          <div>{{ log.email || log.username || 'Desconhecido' }}</div>
        </div>
      </div>
    </div>

    <!-- Section: Registo Afetado -->
    <div class="details-card">
      <div class="section-title">
        <i class="ri-file-text-line"></i> Detalhes da Alteração
      </div>
      <div class="details-grid">
        <div class="detail-item full-width">
          <label>Campo Alterado</label>
          <div class="highlight-value">{{ log.campoAlterado || 'Registo modificado' }}</div>
        </div>
      </div>
    </div>

    <!-- Comparison Box -->
    <div class="comparison-box" [class.has-change]="temAlteracao()">
      <div
        class="comparison-col previous"
        [class.comp-col-empty]="!temValorAnterior()"
      >
        <div class="comp-header">
          <i class="ri-history-line"></i> Valor Anterior
        </div>
        <div
          class="comp-content"
          [class.comp-filled]="temValorAnterior()"
          [class.comp-empty]="!temValorAnterior()"
        >
          {{ formatValor(log.valorAnterior) }}
        </div>
      </div>
      <div class="comparison-divider">
        <i class="ri-arrow-right-line"></i>
      </div>
      <div
        class="comparison-col new"
        [class.comp-col-empty]="!temValorNovo()"
      >
        <div class="comp-header">
          <i class="ri-check-double-line"></i> Valor Novo
        </div>
        <div
          class="comp-content"
          [class.comp-filled]="temValorNovo()"
          [class.comp-empty]="!temValorNovo()"
        >
          {{ formatValor(log.valorNovo) }}
        </div>
      </div>
    </div>
  </div>
</p-drawer>
